import { formatSoles, statusLabel } from "@/api";
import { makePdf, fmtDate, quoteStatus } from "./ui";

export function orderPdf(o, settings, mode) {
  makePdf({
    settings, mode, title: "Pedido", code: o.order_code, date: fmtDate(o.created_at),
    infoRows: [
      ["Cliente", o.customer_name || ""], ["Teléfono", o.customer_phone || ""], ["Email", o.customer_email || "—"],
      ["Distrito / ciudad", o.customer_district || "—"], ["Entrega", [o.shipping_label, o.delivery_date ? fmtDate(o.delivery_date) : ""].filter(Boolean).join(" · ") || "—"],
      ["Método de pago", (o.payment_method || "").toUpperCase()], ["Estado", statusLabel(o.status)],
    ],
    items: o.items || [],
    totals: [
      ["Subtotal", formatSoles(o.subtotal ?? o.total)], ["Descuento", `- ${formatSoles(o.discount || 0)}`],
      ["Envío", formatSoles(o.shipping_cost || 0)], ["TOTAL", formatSoles(o.total)],
      ["Pagado", formatSoles(o.paid || 0)], ["Saldo", formatSoles(o.balance ?? o.total)],
    ],
    notes: o.notes,
  });
}

export function quotePdf(q, settings, mode) {
  makePdf({
    settings, mode, title: "Cotización", code: q.quote_code || "", date: fmtDate(q.created_at),
    infoRows: [
      ["Cliente", q.name || ""], ["WhatsApp", q.whatsapp || ""], ["Tipo", q.customer_type || "—"],
      ["Fecha del evento", q.event_date ? fmtDate(q.event_date) : "—"], ["Lugar", q.district || "—"], ["Estado", quoteStatus(q.status).label],
    ],
    items: q.items || [],
    totals: [
      ["Subtotal", formatSoles(q.subtotal || 0)], ["Descuento", `- ${formatSoles(q.discount || 0)}`],
      ["Envío", formatSoles(q.shipping_cost || 0)], ["TOTAL", formatSoles(q.total || 0)],
    ],
    notes: [q.admin_notes, q.valid_until ? `Válida hasta ${fmtDate(q.valid_until)}` : ""].filter(Boolean).join(" — "),
  });
}
